import { Firestore } from '@angular/fire/firestore';
import { Injectable } from '@angular/core';
import { Regiocoach } from '@models';

import { BaseService } from '../base/base.service';

import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root',
})
export class RegiocoachService extends BaseService<Regiocoach> {
  protected readonly documentPath = 'regiocoaches';

  constructor(
    protected db: Firestore,
    protected toastService: ToastService
  ) {
    super(db, toastService);
  }
}
